/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTracker } from '../tracking/useTracker';
import { Step } from 'signup-constants/Step';
import { emailClientFromDomain, mailOptionsMapper } from './emailUtils';
import { AnimatedButton } from '../animation/ButtonAnimations';
import I18n from 'I18n';
import UIImage from 'UIComponents/image/UIImage';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToMailButton = ({
  email
}) => {
  const stepKey = Step.CodeVerification;
  const emailClient = emailClientFromDomain(email);
  const Tracker = useTracker();
  const [isSelected, setIsSelected] = useState(false);
  const onLoad = () => {
    if (emailClient) {
      Tracker.signupInteraction(`verification-shown-go-to-${emailClient}`);
    }
  };
  useEffect(onLoad, []);
  const getEmailClientLink = () => {
    if (!emailClient) {
      return null;
    }
    const link = mailOptionsMapper[emailClient].link;
    if (link) {
      Tracker.click({
        message: 'click go to mail',
        linkLocation: `verify email button - ${emailClient}`
      });
    }
    return link;
  };
  const handleGoToEmail = () => {
    const link = getEmailClientLink();
    setIsSelected(true);
    const timeout = setTimeout(() => {
      setIsSelected(false);
    }, 500);
    if (link) {
      window.open(link, '_blank');
    }
    return () => {
      clearTimeout(timeout);
    };
  };
  if (!email || !emailClient) {
    return null;
  }
  const logo = mailOptionsMapper[emailClient].logo;
  return /*#__PURE__*/_jsx(AnimatedButton, {
    className: "m-top-4",
    selected: isSelected,
    title: I18n.text(`views.${stepKey}.openEmailButton`),
    onClick: handleGoToEmail,
    children: /*#__PURE__*/_jsx(UIImage, {
      alt: "logo",
      responsive: false,
      src: logo
    })
  });
};
export default GoToMailButton;